/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { Break } from "pages/Schedule/types/Shift";

export enum ShiftBatchStatus {
    Free = "free",
    Assigned = "assigned",
    Pending = "pending",
    Error = "error",
}

export interface ShiftBatch {
    shiftIds: string[];
    startTime: string;
    endTime: string;
    status: ShiftBatchStatus;
    breaks: Break[];
    startLocation: string | null;
    endLocation: string | null;
    selectedShiftId: string | null;
    error: string | null;
    serviceTags: string[];
    overlapped: boolean;
    batchRandomVanId: string | null;
}

export interface ShiftBatchesState {
    shiftBatches: ShiftBatch[];
    selectedDay: Date;
}

export interface ReserveShiftResponse {
    shiftId: string;
    licensePlate: string | null;
    vanId: string | null;
    vanVisualId: string | null;
}

export interface ReserveShiftRequest {
    url: string;
    data: unknown;
}